import {  deleteProfilePhoto,rechargeCredits,fetchCreditsBalance, fetchSportsAndTypes  } from '../../api/user';

const state = {
    user: {},
    message: ''
  };
  
  const mutations = {
    SET_USER(state, user) {
      state.user = user;
    },
    SET_MESSAGE(state, message) {
      state.message = message;
    }
  };

  
const actions = {

 
  async deleteProfilePhoto({ commit }, payload) {
    try {
      const response = await deleteProfilePhoto(payload.userId);
      commit('SET_USER', response.data);
      commit('SET_MESSAGE', response.data.message);
    } catch (error) {
      console.error('An error occurred during photo deletion:', error);
      commit('SET_MESSAGE', 'Photo deletion failed');
    }
  },
  
  async rechargeCredits({ commit }, payload) {
    try {
      const response = await rechargeCredits(
        payload.userId,
        payload.amount,
        payload.paymentIntentId
      );
      commit('SET_USER', response.data);
      commit('SET_MESSAGE', response.data.message);
    } catch (error) {
      console.error('An error occurred during credits recharge:', error);
      commit('SET_MESSAGE', 'Credits recharge failed');
    }
  },
  async fetchCreditsBalance({ commit }, payload) {
    try {
      const response = await fetchCreditsBalance(payload.userId);
      return response.data;
    } catch (error) {
      console.error('An error occurred while fetching credits balance:', error);
      commit('SET_MESSAGE', 'Failed to fetch credits balance');
      return 0;
    }
  },
  async fetchSportsAndTypes({ commit }) {
    try {
      const response = await fetchSportsAndTypes();
      //return response.data;
      return response.data;
    } catch (error) {
      console.error('An error occurred while fetching sports and types list:', error);
      commit('SET_MESSAGE', 'Failed to fetch sports and types list');
      return { sports: [], types: [] };
    }
  },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
  };